import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";

import ModalMasterDetailView from "../../../components/modal/ModalMasterDetailView";
import { propertyOperations } from "../../../modules/definition/properties";
import { typeOperations } from "../../../modules/definition/types";
// import ImmutablePropTypes from "react-immutable-proptypes";
import { PropTypeShapes } from "../../../types";
import SettingsPropertiesDetailView from "./SettingsPropertiesDetailView";

const listItems = props => {
  return props.properties.allIds
    .map(pId => {
      const p = props.properties.byId.get(pId);
      return {
        label: p.label,
        value: p.id,
        color: null,
        icon: null,
        canDelete: p.canDelete
      };
    })
    .toArray();
};

class SettingsPropertiesTab extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <ModalMasterDetailView
        items={listItems(this.props)}
        onItemSelect={this.selectItem}
        onAddClick={this.props.onAddProperty}
        onDeleteClick={this.props.onRemoveProperty}
        allowDrag={true}
        onMoveItemAtIndex={this.props.onMoveProperty}
        backText="Properties"
        itemsUseIndexAsId={false}
        //#!if iOS === true
// onDoneClick={this.props.onDoneClick}
        //#!endif
      >
        <SettingsPropertiesDetailView {...this.props} />
      </ModalMasterDetailView>
    );
  }
}

SettingsPropertiesTab.propTypes = {
  properties: PropTypeShapes.propertyDefinitionsIdList.isRequired,
  types: PropTypeShapes.denormalisedTypeDefinitionsIdList.isRequired,
  dispatchLocal: PropTypes.func.isRequired,
  onToggleAutoCalculate: PropTypes.func.isRequired,
  onAutoCalculateTypeChange: PropTypes.func.isRequired,
  onToggleIndicateItemCompletion: PropTypes.func.isRequired,
  onFormatChange: PropTypes.func.isRequired,
  onAddAllowedValue: PropTypes.func.isRequired,
  onRenameAllowedValue: PropTypes.func.isRequired,
  onDeleteAllowedValue: PropTypes.func.isRequired,
  onMoveAllowedValue: PropTypes.func.isRequired,
  onLabelChange: PropTypes.func.isRequired,
  onIncludeInTypeChange: PropTypes.func.isRequired,
  onAddProperty: PropTypes.func.isRequired,
  onMoveProperty: PropTypes.func.isRequired,
  onRemoveProperty: PropTypes.func.isRequired,
  onEnabledChange: PropTypes.func.isRequired,
  //#!if iOS === true
// onDoneClick: PropTypes.func.isRequired
  //#!endif
};

const mapDispatchToProps = (_dispatch, props) => {
  // Note: We are always using dispatchLocal here so that the action only travels
  // back to the Settings Modal.
  // Changes are committed to the root store only when the dialog is confirmed.
  return {
    onFormatChange: (propertyId, format) => {
      props.dispatchLocal(propertyOperations.changeFormat(propertyId, format));
    },
    onLabelChange: (propertyId, label) => {
      props.dispatchLocal(propertyOperations.changeLabel(propertyId, label));
    },
    onToggleAutoCalculate: propertyId => {
      props.dispatchLocal(propertyOperations.toggleAutoCalculate(propertyId));
    },
    onAutoCalculateTypeChange: (propertyId, newType) => {
      props.dispatchLocal(propertyOperations.changeAutoCalculateType(propertyId, newType));
    },
    onToggleIndicateItemCompletion: propertyId => {
      props.dispatchLocal(propertyOperations.toggleIndicateItemCompletion(propertyId));
    },
    onAddAllowedValue: (propertyId, value) => {
      props.dispatchLocal(propertyOperations.addAllowedPropertyValue(propertyId, value));
    },
    onRenameAllowedValue: (propertyId, valueId, newValue) => {
      props.dispatchLocal(propertyOperations.renameAllowedPropertyValue(propertyId, valueId, newValue));
    },
    onDeleteAllowedValue: (propertyId, valueId) => {
      props.dispatchLocal(propertyOperations.deleteAllowedPropertyValue(propertyId, valueId));
    },
    onMoveAllowedValue: (propertyId, oldIndex, newIndex) => {
      props.dispatchLocal(propertyOperations.moveAllowedPropertyValue(propertyId, oldIndex, newIndex));
    },
    onIncludeInTypeChange: (typeId, propertyId, isIncluded) => {
      props.dispatchLocal(typeOperations.changeHasProperty(typeId, propertyId, isIncluded));
    },
    onAddProperty: () => {
      props.dispatchLocal(propertyOperations.createProperty());
    },
    onMoveProperty: (fromIndex, toIndex) => {
      props.dispatchLocal(propertyOperations.moveProperty(fromIndex, toIndex));
    },
    onRemoveProperty: propertyId => {
      props.dispatchLocal(propertyOperations.deleteProperty(propertyId));
    },
    onEnabledChange: (propertyId, enabled) => {
      props.dispatchLocal(propertyOperations.changeEnabled(propertyId, enabled));
    }
  };
};

export default connect(null, mapDispatchToProps)(SettingsPropertiesTab);
